import DialogPortal from "components/portal/DialogPortal/DialogPortal";
import { createContext, useContext } from "react";
import styled from "styled-components";

interface DialogOverlayProviderProps {
  $size: "large" | "small";
  $state: "info" | "warning" | "error" | "success";
  $preventClose?: boolean;
}

const StyledDialog = styled.div<DialogOverlayProviderProps>`
  & > .container {
    width: ${({ $size }) => ($size === "large" ? "55rem" : "40rem")};
    min-height: ${({ $size }) => ($size === "large" ? "35rem" : "25rem")};
    height: max-content;
    display: flex;
    flex-flow: column nowrap;
    box-sizing: border-box;
    background-color: var(--bg-gray-normal);
    border-radius: 0.8rem;
    box-shadow: var(--shadow-modal);

    position: relative;
    transform: translate(0, 0);
    will-change: transform;
  }
`;

const DialogOverlayContext = createContext<
  DialogOverlayProviderProps | undefined
>(undefined);

export const useDialogOverlayContext = () => {
  const context = useContext(DialogOverlayContext);
  if (!context) {
    throw new Error(
      "useDialogOverlayContext must be used within a DialogProvider"
    );
  }
  return context;
};

export const StyledDialogProvider: React.FC<{
  $size: "large" | "small";
  $state: "info" | "warning" | "success" | "error";
  children: React.ReactNode;
  $zIndex?: string;
  $preventClose?: boolean;
}> = ({ $size, $state, children, $zIndex, $preventClose = false }) => {
  return (
    <DialogOverlayContext.Provider value={{ $size, $state, $preventClose }}>
      <DialogPortal $zIndex={$zIndex}>
        <StyledDialog $size={$size} $state={$state}>
          {children}
        </StyledDialog>
      </DialogPortal>
    </DialogOverlayContext.Provider>
  );
};
